import React from 'react';
import PropTypes from 'prop-types';
import reducer, { sketchDefaultZoomLevel } from './reducer';

const initialState = {
  loading: false,
  error: null,
  layers: [],
  layerData: [],
  zoomLevel: sketchDefaultZoomLevel,
  selectedLayerId: null,
  selectedPopupLayerId: null,
  mode: 'aerial',
  tapeFeatures: [],
  tapeFeaturesHistory: [],
  tapeFeaturesRedoStack: [],
  tapeConfig: null,
  selectedTapeFeatureId: null,
  tapeSketch: null,
};

const SketchToolContext = React.createContext(initialState);

const SketchToolProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return <SketchToolContext.Provider value={{ state, dispatch }}>{children}</SketchToolContext.Provider>;
};

SketchToolProvider.propTypes = {
  children: PropTypes.any,
};

export { SketchToolContext, SketchToolProvider };
